import React, { useEffect, useMemo } from 'react';
import usePopupMessage from '@/widget/ui/hooks/usePopupMessage';
import cx from 'classnames';
import botImage from '@/widget/ui/images/bot.svg';
import botImageDark from '@/widget/ui/images/bot-dark.svg';
import closeButton from '@/widget/ui/images/close.svg';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { isLight } from '@/lib/colors/colors';
import QuestionButton from './QuestionButton';
import styles from './PopupMessage.module.scss';

function PopupMessage() {
  const { settings } = useChatWidgetContext();
  const {
    isMobile,
    position,
    host,
    color,
  } = settings;

  const {
    quickAnswers,
    invitationText,
    displayInvitation,
    setTouched,
    startConversation,
  } = usePopupMessage();
  const botIcon = useMemo(() => (isLight(color) ? botImageDark : botImage), [color]);

  useEffect(() => {
    if (displayInvitation) {
      const event = new CustomEvent('s2:widget:message:new', { detail: { key: 'invitation' } });
      dispatchEvent(event);
    }
  }, [displayInvitation, host]);

  return (
    <>
      { displayInvitation && (
        <div className={cx(styles.invitationContainer, styles[position], { [styles.mobile]: isMobile })}>
          <div className={cx(styles.invitationMessage, styles[position])}>
            <div
              style={{ backgroundColor: color }}
              className={cx(styles.invitationLogo, styles[position])}
            >
              <img src={`${host}${botIcon}`} alt="bot" />
            </div>
            <div
              className={cx(styles.invitationText, styles[position])}
              onClick={() => startConversation()}
            >
              {invitationText}
            </div>
            <div
              style={{ backgroundImage: `url("${host}${closeButton}")` }}
              className={cx(styles.invitationClose, { [styles.mobile]: isMobile })}
              onClick={() => setTouched(true)}
            />
          </div>
          <div
            className={cx(styles.input, styles[position])}
            onClick={() => startConversation()}
          >
            {window.ChatWidget.i18n.t('chat_widget.invitation.input')}
          </div>
          <div className={cx(styles.templates, styles[position])}>
            {quickAnswers.map((template) => (
              <QuestionButton key={template} template={template} startConversation={startConversation} />
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default PopupMessage;
